// extracted by mini-css-extract-plugin
export default {"container":"hr-z","brandName":"ir-z","productName":"jr-z","productNamePdpEnhancements":"kr-z","breakLongProductName":"lr-z"};